var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interested lead mt-3"},[_c('b-form-checkbox',{attrs:{"unchecked-value":"false"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_vm._v(" Me interesa este servicio ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }